// Holat matni → Badge varianti. Matnlar prototipdagi holatlar (o'zbekcha).
const normalize = (text) =>
  String(text || '')
    .toLowerCase()
    .replace(/[ʻʼ’`‘]/g, "'")
    .trim();

const GROUPS = {
  success: [
    'faol', 'tasdiqlangan', 'bajarildi', "to'langan", "o'tdi", 'mos', 'yopiq', 'chop etilgan', 'yoqilgan', 'ok',
    'imzolangan', 'bitirgan', "ko'rib chiqilgan", 'bor', 'past', 'topshirdi', 'tugatgan', "ulangan", 'qayta ulandi', 'tayyor',
  ],
  warning: [
    'kutilmoqda', "ko'rib chiqilmoqda", 'qisman', 'eslatma', 'kuzatuvda', 'jarayonda', "ta'til so'rovi", "o'rta",
    'kalibrovka', 'komissiyaga yuborildi', "qaytarish so'rovi", 'litsenziyalash', 'imzoga tayyor', 'muzokara',
    'taklif', 'maslahat', "direktor tasdig'ini kutmoqda", 'kutish', 'ogohlantirish', "o'qimoqda", 'tekshiruvda',
    'balans kam', 'taklif yuborildi', "o'chirilgan",
  ],
  danger: [
    'istisno', 'yuqori', "muddati o'tgan", 'xavf', 'rad etildi', 'bekor qilingan', 'bloklandi', 'farq', 'ochiq',
    "o'tmadi", 'qaytarilgan', "natija bekor, qayta topshirish", "yo'q", 'muddati tugagan',
  ],
  info: [
    'yangi', 'loyiha', 'yaqin voqealar', "oldindan ko'rish", 'uslubiy tekshiruv', 'til tekshiruvi', 'sifat tekshiruvi',
    'tasdiqlash', 'katalogga chiqarish', 'shartnoma', 'suhbat', 'hujjatlar', 'rejalashtirilgan', 'qoralama', 'promokod',
  ],
};

const LOOKUP = Object.entries(GROUPS).reduce((acc, [variant, words]) => {
  words.forEach((word) => {
    acc[word] = variant;
  });
  return acc;
}, {});

export function statusVariant(text) {
  const key = normalize(text);
  if (LOOKUP[key]) return LOOKUP[key];
  if (key.startsWith('bloklandi')) return 'danger';
  if (key.startsWith('farq')) return 'danger';
  if (key.includes('kun qoldi')) return 'warning';
  return 'neutral';
}
